<template>
    <div class="container-fluid content-page-wrapper">
        <div class="row py-5">
            <div class="col-sm-12 col-md-6 m-auto">
                <h1>{{ $t('Sign in') }}</h1>
                <login-form></login-form>
            </div>
        </div>
    </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';

export default {

    mounted() {
      this.redirectLoggedInUser();
    },

    methods: {
        redirectLoggedInUser() {
            if (this.authenticated) {
                this.$router.push({ name: 'home' });
            }
        }
    },

    computed: {

        ...mapGetters({
            authenticated: 'auth/authenticated',
            user: 'auth/user',
            permissions: 'auth/permissions'
        }),

    },

}
</script>
